import React from 'react';
import { StarIcon } from 'lucide-react';
import { Reveal, Eyebrow } from './Section';
const testimonials = [{
  name: 'Camila R.',
  quote: 'Armé mi portfolio en una semana y a los pocos días conseguí mi primera marca. No podía creer que no necesitaba seguidores.',
  initial: 'C'
}, {
  name: 'Valentina M.',
  quote: 'Los mensajes para contactar marcas me cambiaron todo. Dejé de sentir que pedía un favor y empecé a cobrar en dólares.',
  initial: 'V'
}, {
  name: 'Sofía L.',
  quote: 'Nunca había grabado un video de producto y con el celular hice muestras que se ven súper profesionales. Vale cada peso.',
  initial: 'S'
}];
export function Testimonials() {
  return <section className="w-full bg-plum py-16 text-cream sm:py-24" data-id="element-180" data-mp="2s39p2f6eo9df">
      <div className="mx-auto max-w-6xl px-5 sm:px-6" data-id="element-181" data-mp="v9oojjm9rg2g">
        <Reveal className="mx-auto max-w-2xl text-center" data-id="element-182" data-mp="v7c6l6gih5pe">
          <span className="inline-block text-xs font-semibold uppercase tracking-[0.2em] text-gold-soft" data-id="element-183" data-mp="qbn7134hrot3">
            Historias reales
          </span>
          <h2 className="mt-4 font-display text-3xl font-semibold leading-tight sm:text-4xl" data-id="element-184" data-mp="m51cjvsy5da0">
            Creadoras que ya dieron su primer paso
          </h2>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-3" data-id="element-185" data-mp="79v6x9xrjgh7">
          {testimonials.map((t, i) => <Reveal key={t.name} delay={i * 0.08} data-id="element-186" data-mp="c8okf2d1v7hd" data-mpi={i}>
              <div className="flex h-full flex-col rounded-2xl bg-[#4a2231] p-7 shadow-soft" data-id="element-187" data-mp="zxhc2mmn2t66">
                <div className="flex gap-1" data-id="element-188" data-mp="14uhgyu7r5pvp">
                  {[...Array(5)].map((_, s) => <StarIcon key={s} className="h-4 w-4 fill-gold text-gold" data-id="element-189" data-mp="q5lav2p9amxq" data-mpi={s} />)}
                </div>
                <p className="mt-4 flex-1 text-cream/90" data-id="element-190" data-mp="v44z59rboat9">“{t.quote}”</p>
                <div className="mt-6 flex items-center gap-3" data-id="element-191" data-mp="1iv1w9gegl3kg">
                  <span className="flex h-11 w-11 items-center justify-center rounded-full bg-coral font-display text-lg font-semibold text-white" data-id="element-192" data-mp="1nm0ggr2kilsz">
                    {t.initial}
                  </span>
                  <span className="font-medium text-cream" data-id="element-193" data-mp="1siwcygaqts6q">{t.name}</span>
                </div>
              </div>
            </Reveal>)}
        </div>
      </div>
    </section>;
}